import React, { useEffect, useState } from "react";
import FormControl from "@material-ui/core/FormControl";
import { MenuItem, Select } from "@material-ui/core";
import Table from "../../../FlowConfigurationInputs/Table/Table";

function FilterRowsCells({ action, variables, setOpenVariable, automVersionId }) {
    const label = "CONTENT.CONFIGURATION-FORM.PRE-PROCESSING.";
    const [output, setOutput] = useState("");
    const [matchMode, setMatchMode] = useState("");
    const [normalization, setNormalization] = useState("");
    const headers = ["has values"];
    const options = {
        tableBody: { headers, title: "values" },
        checkboxes: { label: label + "TRUNCATE" },
        checkboxesSecond: { label: label + "KEEP-EMPTY-CHUNKS" },
    };

    // set localtype initial value
    useEffect(() => {
        if (!action.fields.outputAs) {
            action.fields.outputAs = { value: "" };
        } else {
            setOutput(action.fields.outputAs.value);
        }
    }, [variables, action]);

    // set selected local type
    function handleLocalType(event) {
        setOutput(event.target.value);
        action.fields.outputAs.value = event.target.value;
    }
    function handleMatch(event) {
        setMatchMode(event.target.value);

    }
    function handleNormalization(event) {
        setNormalization(event.target.value);

    }
    return (
        <div>
            <div className="form-element">
                Action
                <FormControl variant="outlined" fullWidth>
                    <Select
                        value={output}
                        onChange={handleLocalType}
                    >
                        <MenuItem value="onlyMatchRows">
                            Only keep matching rows
                        </MenuItem>
                        <MenuItem value="removeMatchReows">Remove matching rows</MenuItem>
                        <MenuItem value="clearMatchingCells">Clear matching cells</MenuItem>
                        <MenuItem value="clearNonMatchingCells">Clear non matching cells</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className="form-element">
                Column
                <Table
                    action={action}
                    inputName="columns"
                    automVersionId={automVersionId}
                    options={options.tableBody}
                    setOpenVariable={setOpenVariable}
                    isRequired={false}
                    isActiveDirectory={true}
                />
            </div>
            <div className="form-element">
                Match mode
                <FormControl variant="outlined" fullWidth>
                    <Select
                        value={matchMode}
                        onChange={handleMatch}
                    >
                        <MenuItem value="onlyMatchRows">
                            Complete Value
                        </MenuItem>
                        <MenuItem value="removeMatchReows">Complete </MenuItem>
                        <MenuItem value="clearMatchingCells">Substring</MenuItem>
                        <MenuItem value="clearNonMatchingCells">Regular Expression</MenuItem>
                    </Select>
                </FormControl>
            </div>
            <div className="form-element">
                Normalization Mode
                <FormControl variant="outlined" fullWidth>
                    <Select
                        value={normalization}
                        onChange={handleNormalization}
                    >
                        <MenuItem value="onlyMatchRows">
                            Exact (no transformation)
                        </MenuItem>
                        <MenuItem value="removeMatchReows">Ignore Case </MenuItem>
                        <MenuItem value="clearMatchingCells">Normalize (ignore accents)</MenuItem>
                    </Select>
                </FormControl>
            </div>
        </div>
    );
}
export default FilterRowsCells;